/**
 * @author: junjunzuo(junjunzuo@tencent.com)
 * @description: 视频垂搜首页
 * @Date: 2020-06-29 10:41:15
 */
import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    head: '',
    spver: 0,
  }),
  mutations: {
    [types.UPDATE_HEAD](state, head) {
      state.head = head;
    },
    [types.UPDATE_HOME_SPVER](state, spver) {
      state.spver = spver;
    },
  },
  actions: {
    async prefetchData({ commit }, { context, route }) {
      const $params = context ? context.$params : {};
      const params = Object.assign({}, route.query, { routeName: route.name }, $params);
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/home`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));

      result = result && result.data;
      const { status, head = '', spver = 0 } = result || {};
      if (status === 301) return result;
      commit(types.UPDATE_HEAD, status === 0 ? head : '');
      commit(types.UPDATE_HOME_SPVER, +route.query.spver === 1 ? 1 : spver);
      return result || {};
    },
  },
};
